module.exports = __webpack_public_path__ + "static/media/message.7dbf2f58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/noticeboard/message.svg
// module id = 568
// module chunks = 0